<template>
    <a @click="impersonate(columnData)">Impersonate</a>
</template>

<script>
import users from "../../services/users.service";

export default {
    props: {
        columnData: Number
    },

    methods: {
        impersonate(userId) {
            users.getAdminToken(userId).then(response => {
                let token = response.data
                let link = this.mainDomain + '/impersonate/' + this.$store.state.token + '/' + token
                window.open(link, '_blank')
            })
        },

    }
}
</script>

<style scoped>

</style>